import CertificateService from "./certificate_service";
import ContactService from "./contact_service";
import EducationalService from "./education_service";
import ProfessionalService from "./professional_service";
import ProjectService from "./project_service";
import SkillService from "./skill_service";

const contactService = new ContactService();
const projectService = new ProjectService();
const educationalService = new EducationalService();
const certificateService = new CertificateService();
const professionalService = new ProfessionalService();
const skillService = new SkillService();

export {
    contactService, projectService, educationalService, certificateService, professionalService, skillService
}